module.exports = __webpack_public_path__ + "img/olivera_popovic.3d66c67d.png";